import Axios from 'axios';
import Env from '@/plugins/protokol/lib/Env'

const http = Axios.create({
  baseURL: Env.get('API_HOST'),
  timeout: 30000,
  responseType: 'json'
});

http.defaults.withCredentials = true

http.interceptors.request.use(function(config) {
  config.headers["X-Project-Uuid"] = config.headers['X-Project-Uuid'] || localStorage.getItem("current_project_uuid")
  config.headers["X-Workspace-Uuid"] = config.headers['X-Workspace-Uuid'] || localStorage.getItem("current_workspace_uuid")
  
  if (config.headers["X-Project-Env"] === undefined)
    config.headers["X-Project-Env"] = localStorage.getItem("current_env") || "live"

  config.headers["Accept-Language"] = localStorage.getItem("locale") || 'en_US'

  return config
});

export default http